import React, { Component } from 'react';
import { userStatus, envConfig, history } from '../../../_helpers';
import { Loader } from '../../../_components';
import * as chartjs from 'chart.js';
import 'chartjs-plugin-datalabels';
import queryString from 'query-string';

chartjs.defaults.global.plugins.datalabels.align = 'end'; 
export default class DevicesPageview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: '',
      domain_root: '',
      desktop_data: [],
      mobile_data: [],
      labels: [],
      loaded: false
    }

    this.chartRefDesktop = React.createRef();
    this.chartRefMobile = React.createRef();
  }

  async componentDidMount() {
    if ( sessionStorage.getItem('selected_domain') ) {
      let data = await JSON.parse(sessionStorage.getItem('selected_domain'));
      this.listAnalyticsData(data.uuid);
    }
  }

  async componentWillReceiveProps(nextProps) {
    await this.setState({
      loaded: false,
      period: nextProps.period,
      domain: queryString.parse(history.location.search).domain
    }, () => this.listAnalyticsData(this.state.domain, nextProps.period));
  }

  async listAnalyticsData(domain) {
    const user = userStatus();
    let { endpoint } = this.state;

    let url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?period=${this.props.period}`;
    let options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${user.bearer_token}`
      }
    }

    let request = await fetch(url, options);

    if ( request.status !== 200 ) return Promise.reject(await request.json());
    let response = await request.json();
    if ( response.data.length === 0 ) response.data = 0;
    
    this.setState({
      desktop_data: response.data.desktop,
      mobile_data: response.data.mobile,
      loaded: true
    });
  }

  render() {
    return (
      <div className="col">
        <div className="row">
          
          <div className="col">
            <div className="card">
              <p className="title title-outside">{this.props.title} (desktop)</p>

              {
                this.state.desktop_data && this.state.loaded === true ?
                  <div className="table-responsive table-responsive-height">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>URL</th>
                          <th>Visitas</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.desktop_data.length > 0 ?
                            this.state.desktop_data.map(data => {
                                return <tr>
                                  <td>{data.url.replace(`https://${this.state.domain_root}`, '')}</td>
                                  <td>{data.count}</td>
                                </tr>
                            })
                          : null
                        }
                      </tbody>
                    </table>
                  </div>
                : <Loader className="is-blue" />
              }
            </div>
          </div>

          <div className="col">
            <div className="card">
              <p className="title title-outside">{this.props.title} (mobile)</p>

              {
                this.state.mobile_data && this.state.loaded === true ?
                  <div className="table-responsive table-responsive-height">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>URL</th>
                          <th>Visitas</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.mobile_data.length > 0 ?
                            this.state.mobile_data.map(data => {
                                return <tr>
                                  <td>{data.url.replace(`https://${this.state.domain_root}`, '')}</td>
                                  <td>{data.count}</td>
                                </tr>
                            })
                          : null
                        }
                      </tbody>
                    </table>
                  </div>
                : <Loader className="is-blue" />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}